import React from 'react'
import { useUpdateBazaarvoiceStyles } from '../../hooks/useUpdateBazaarvoiceStyles'

const BazaarvoiceContainer = ({ productId }) => {
  useUpdateBazaarvoiceStyles()
  // placing the divs for bazaarvoice to allow them to attach their fragments
  return (
    <div>
      <div data-bv-show='reviews' data-bv-product-id={productId} className='bv-reviews' />
      <div data-bv-show='questions' data-bv-product-id={productId} />
    </div>
  )
}
export default React.memo(BazaarvoiceContainer)
